import React, { Component, Fragment } from 'react';
import { browserHistory } from 'react-router';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';

import { connect } from 'react-redux';

import Auth from 'j-toker';
import Lottie from 'react-lottie';
import successAnimationData from 'assets/success.json';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';

import LandlordLogo from 'components/shared/LandlordLogo';
import LoginNavBar from 'navigation/login/loginWithBackground/LoginNavBar';

import {
  StyledContainer,
  StyledContainerOverlay,
  StyledRow,
  StyledColumn,
  StyledButton,
  ButtonContainerStyled,
  StyledATag,
} from 'helpers/StyledLoginComponentsHelper';
import {
  passwordValidation,
  passwordValidationWeak,
  passwordConfirmationValidation,
} from 'helpers/PasswordHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import LoginHelpDialog from 'navigation/LoginHelpDialog';
import PasswordRequirements from '../PasswordRequirements';

const StyledCard = styled(Card)`
  color: #424242 !important;
  font-family: 'Circular' sans-serif !important;
  overflow: hidden;
  border-radius: 8px;
  padding: 15px;
  margin-top: 0;
  width: 550px;
`;

const StyledCardContent = styled(CardContent)`
  padding: 0 0 10px;
`;

const StyledLoginMessageH2 = styled.h2`
  padding: 0 0 10px;
  font-size: 36px;
`;

const StyledP = styled.p`
  margin: 10px 0;
  font-size: 17px;
  ${props => (props.mobile ? 'padding: 0 24px;' : null)};
`;

const StyledMobileContainer = styled.div`
  font-family: 'Circular', sans-serif !important;
  padding: 24px;
  background: white;
`;

const StyledMobileCentered = styled.div`
  text-align: center;
  margin-top: 24px;
`;

const defaultAnimationOptions = {
  loop: false,
  autoplay: true,
  animationData: successAnimationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

let Login = connect(store => {
  return {
    userType: store.userTypes.loginAuth,
    landlordId: store.userTypes.landlordId,
    accountProviderIsSSO: store.userTypes.accountProviderIsSSO,
    heroImageUrl: store.userTypes.heroImageUrl,
  };
})(
  class PasswordReset extends Component {
    constructor(props) {
      super(props);
      this.props = props;
      this.state = {
        password: '',
        password_confirmation: '',
        isButtonEnabled: false,
        hasUpdatedPassword: false,
        errorMessage: '',
        loginHelpOpen: false,
      };
    }

    handleInputChange = event => {
      this.setState(
        {
          [event.target.name]: event.target.value.trim(),
          errorMessage: '',
        },
        () => {
          if (this.handlePasswordValidation()) {
            this.setState({ isButtonEnabled: true });
          }
        }
      );
    };

    handlePasswordValidation = () => {
      const { password, password_confirmation } = this.state;
      let validPassword = false;

      if (this.props.userType === 'maintenance') {
        validPassword = passwordValidationWeak(password);
      } else {
        validPassword = passwordValidation(password);
      }
      return validPassword && passwordConfirmationValidation(password, password_confirmation);
    };

    handleLoginHelpOpenClose = openClose => {
      this.setState({
        loginHelpOpen: openClose,
      });
    };

    handleLanguageChange = () => {
      const languageCode = getCurrentLocale() === 'fr' ? 'en' : 'fr';
      this.props.updateLanguage(languageCode);
      localStorage.setItem('locale', languageCode);
      this.forceUpdate();
      window.location.reload();
    };

    getUrlForUserType = userType => {
      if (userType === 'landlord') return '/companies';
      if (userType === 'maintenance') return '/maintenance';
      return '/';
    };

    getHelpLinkForUserType = userType => {
      if (userType === 'landlord' || userType === 'maintenance') {
        return 'https://yuhu.zendesk.com/hc/en-us/categories/360000075758-Partner-Center-Landlords';
      }
      return 'https://yuhu.zendesk.com/hc/en-us/categories/360000073757-Partner-Center-Residents';
    };

    handleUpdatePassword = () => {
      const { password, password_confirmation } = this.state;
      this.setState({ isButtonEnabled: false });

      const auth = Auth;
      const query = browserHistory.getCurrentLocation().query;

      Auth.updatePassword({
        password: password,
        password_confirmation: password_confirmation,
        config: this.props.userType,
        reset_password_token: query.reset_password_token,
      })
        .then(_response => {
          auth.configDfd = null;
          this.setState({ hasUpdatedPassword: true, errorMessage: '' });
          this.props.showSuccess(getTranslatedString('success.passwordUpdated'));
        })
        .catch(error => {
          auth.configDfd = null;
          this.setState({ isButtonEnabled: true });
          if (error.data.errors) {
            if (error.data.errors[0] === 'Unauthorized') {
              this.setState({ errorMessage: getTranslatedString('passwordTokenExpired') });
            } else if (error.data.errors.full_messages[0] === 'Password was used previously.') {
              this.setState({ errorMessage: getTranslatedString('passwordUsedPreviously') });
            }
          } else {
            this.setState({ errorMessage: getTranslatedString('unknownError') });
          }
        });
    };

    render() {
      if (this.props.accountProviderIsSSO === true && this.props.userType === 'landlord') {
        browserHistory.push('/companies');
        return null;
      }

      const { userType } = this.props;
      const loginUrl = this.getUrlForUserType(userType);
      const helpLink = this.getHelpLinkForUserType(userType);
      const isMaintenanceUser = userType === 'maintenance';

      return (
        <Fragment>
          {this._renderDesktop(loginUrl, helpLink, isMaintenanceUser)}
          {this._renderMobile(loginUrl, helpLink, isMaintenanceUser)}

          <LoginHelpDialog
            isOpen={this.state.loginHelpOpen}
            handleClose={() => this.handleLoginHelpOpenClose(false)}
            stage="passwordReset"
          />
        </Fragment>
      );
    }

    _renderMobile = (loginUrl, helpLink, isMaintenanceUser) => {
      return (
        <MediaQuery query="(max-device-width: 750px)">
          <div style={{ backgroundColor: 'white' }}>
            <LoginNavBar
              mobile
              img={this.props.heroImage}
              handleLanguageChange={this.handleLanguageChange}
              handleLoginHelpOpenClose={this.handleLoginHelpOpenClose}
              helpLink={helpLink}
            />
            <StyledMobileContainer>
              <StyledMobileCentered id={'main-login-message'}>
                {this.state.hasUpdatedPassword ? (
                  <PasswordSuccessfullyUpdated
                    isMobile={true}
                    buttonCallback={() => browserHistory.push(loginUrl)}
                  />
                ) : (
                  <MobilePasswordInputFields
                    password={this.state.password}
                    password_confirmation={this.state.password_confirmation}
                    errorMessage={this.state.errorMessage}
                    handleInputChange={this.handleInputChange}
                    handleUpdatePassword={this.handleUpdatePassword}
                    isButtonEnabled={this.state.isButtonEnabled}
                    backToLoginUrl={loginUrl}
                    isMaintenanceUser={isMaintenanceUser}
                  />
                )}
              </StyledMobileCentered>
            </StyledMobileContainer>
          </div>
        </MediaQuery>
      );
    };

    _renderDesktop = (loginUrl, helpLink, isMaintenanceUser) => {
      return (
        <MediaQuery query="(min-device-width: 750px)">
          <StyledContainer img={this.props.heroImage} ref="appContainer">
            <StyledContainerOverlay img={this.props.heroImage}>
              <LoginNavBar
                img={this.props.heroImage}
                handleLanguageChange={this.handleLanguageChange}
                handleLoginHelpOpenClose={this.handleLoginHelpOpenClose}
                helpLink={helpLink}
              />
              <StyledRow>
                <StyledColumn>
                  <StyledCard>
                    <StyledCardContent>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="row" id={'main-login-message'}>
                            <LandlordLogo
                              fontSize="90px"
                              maxWidth="273px"
                              height="100px"
                              textHeight="70px"
                              textAlign="left"
                            />
                            {this.state.hasUpdatedPassword ? (
                              <PasswordSuccessfullyUpdated
                                buttonCallback={() => browserHistory.push(loginUrl)}
                              />
                            ) : (
                              <DesktopPasswordInputFields
                                password={this.state.password}
                                password_confirmation={this.state.password_confirmation}
                                errorMessage={this.state.errorMessage}
                                handleInputChange={this.handleInputChange}
                                handleUpdatePassword={this.handleUpdatePassword}
                                isButtonEnabled={this.state.isButtonEnabled}
                                backToLoginUrl={loginUrl}
                                isMaintenanceUser={isMaintenanceUser}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </StyledCardContent>
                  </StyledCard>
                </StyledColumn>
              </StyledRow>
            </StyledContainerOverlay>
          </StyledContainer>
        </MediaQuery>
      );
    };
  }
);

const MobilePasswordInputFields = ({
  password,
  password_confirmation,
  handleInputChange,
  errorMessage,
  handleUpdatePassword,
  isButtonEnabled,
  backToLoginUrl,
  isMaintenanceUser = false,
}) => (
  <Fragment>
    <StyledLoginMessageH2 aria-level="1">
      {getTranslatedString('setNewPassword')}
    </StyledLoginMessageH2>
    <StyledP mobile>
      {errorMessage && (
        <div>
          <p
            style={{
              color: 'red',
              marginTop: '0',
              marginBottom: '14px',
              fontWeight: '600',
              fontSize: '16px',
              width: '80%',
              display: 'inline-block',
            }}
          >
            {errorMessage}
          </p>
        </div>
      )}
    </StyledP>
    <div style={{ textAlign: 'left', marginBottom: '20px' }}>
      <TextField
        name="password"
        label={getTranslatedString('enterPassword')}
        onChange={handleInputChange}
        value={password}
        type="password"
        variant="outlined"
        style={{ marginTop: '5px' }}
      />
      <TextField
        name="password_confirmation"
        label={getTranslatedString('repeatPassword')}
        onChange={handleInputChange}
        value={password_confirmation}
        type="password"
        variant="outlined"
        style={{ marginTop: '15px' }}
      />
    </div>
    {/* Only show secure password requirements for lead and agent */}
    {!isMaintenanceUser && PasswordRequirements(password, password_confirmation)}
    <div className="row" style={{ marginTop: '30px' }}>
      <ButtonContainerStyled>
        <StyledButton
          name="submit"
          inputProps={{ 'aria-label': getTranslatedString('resetPassword') }}
          data-testid="login-button"
          id={'login-button'}
          accentColor={AccentColor()}
          primary={true}
          onClick={handleUpdatePassword}
          disabled={!isButtonEnabled}
          labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
        >
          {getTranslatedString('resetPassword')}
        </StyledButton>
      </ButtonContainerStyled>
      <ButtonContainerStyled>
        <StyledATag href={backToLoginUrl}>
          {getTranslatedString('passwordReset.backToLogin')}
        </StyledATag>
      </ButtonContainerStyled>
    </div>
  </Fragment>
);

const DesktopPasswordInputFields = ({
  password,
  password_confirmation,
  handleInputChange,
  errorMessage,
  handleUpdatePassword,
  isButtonEnabled,
  backToLoginUrl,
  isMaintenanceUser = false,
}) => (
  <Fragment>
    <div style={{ textAlign: 'left' }}>
      <StyledLoginMessageH2 aria-level="1">
        {getTranslatedString('setNewPassword')}
      </StyledLoginMessageH2>
      <StyledP>
        {errorMessage && (
          <div>
            <p
              style={{
                color: 'red',
                marginTop: '0',
                marginBottom: '14px',
                fontWeight: '600',
                fontSize: '16px',
                width: '80%',
                display: 'inline-block',
              }}
            >
              {errorMessage}
            </p>
          </div>
        )}
      </StyledP>
    </div>
    <div className="row" style={{ textAlign: 'left', marginBottom: '20px' }}>
      <TextField
        name="password"
        label={getTranslatedString('enterPassword')}
        onChange={handleInputChange}
        value={password}
        type="password"
        variant="outlined"
        style={{ marginTop: '5px' }}
      />
      <TextField
        name="password_confirmation"
        label={getTranslatedString('repeatPassword')}
        onChange={handleInputChange}
        value={password_confirmation}
        type="password"
        variant="outlined"
        style={{ marginTop: '15px' }}
      />
    </div>
    {/* Only show secure password requirements for lead and agent */}
    {!isMaintenanceUser && PasswordRequirements(password, password_confirmation)}
    <div className="row" style={{ textAlign: 'left', marginTop: '30px' }}>
      <ButtonContainerStyled>
        <StyledButton
          name="submit"
          inputProps={{ 'aria-label': getTranslatedString('resetPassword') }}
          data-testid="login-button"
          id={'login-button'}
          primary={true}
          onClick={handleUpdatePassword}
          accentColor={AccentColor()}
          disabled={!isButtonEnabled}
          labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
        >
          {getTranslatedString('resetPassword')}
        </StyledButton>
      </ButtonContainerStyled>
      <ButtonContainerStyled style={{ marginRight: '0' }}>
        <StyledATag href={backToLoginUrl}>
          {getTranslatedString('passwordReset.backToLogin')}
        </StyledATag>
      </ButtonContainerStyled>
    </div>
  </Fragment>
);

const PasswordSuccessfullyUpdated = ({ isMobile = false, buttonCallback }) => (
  <Fragment>
    {isMobile && <Lottie options={defaultAnimationOptions} height={150} width={150} />}
    <div>
      <StyledLoginMessageH2 aria-level="1">
        {getTranslatedString('passwordUpdated')}
      </StyledLoginMessageH2>
      <StyledP>{getTranslatedString('passwordUpdatedText')}</StyledP>
    </div>
    <ButtonContainerStyled>
      <StyledButton
        name="submit"
        inputProps={{ 'aria-label': getTranslatedString('passwordReset.backToLogin') }}
        primary={true}
        onClick={buttonCallback}
        labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
        accentColor={AccentColor()}
      >
        {getTranslatedString('passwordReset.backToLogin')}
      </StyledButton>
    </ButtonContainerStyled>
  </Fragment>
);

export default Login;
